import { useMemo, useState } from 'react';
import { Box, Button, Flex, FlexItem, Panel } from '@bigcommerce/big-design';
import Table from '../../../../../components/Table';
import {
	createDefaultRenderer,
	getProductsAndAddons,
} from '../../../../../utils';
import { useOrderProducts } from '../../../context';
import { useFormatCurrency } from '../../../hooks/useFormatCurrency';
import { useSubtotal } from '../../../hooks/useSubtotal';
import { removeProducts } from '../../../store/orderProducts';
import {
	ColorColumn,
	DescriptionOptionsColumn,
	DiagramColumn,
	EditQuantityColumn,
	InStockColumn,
	MakeModelColumn,
	PriceEditColumn,
	RowNumberColumn,
} from './Columns';

const tableColumns = [
	{ hash: 'diagram', header: '', render: DiagramColumn },
	{ hash: 'year', header: 'Year', render: createDefaultRenderer('year') },
	{ hash: 'make_model', header: 'Make/Model', render: MakeModelColumn },
	{
		hash: 'vendor',
		header: 'Vendor',
		render: createDefaultRenderer('vendor'),
	},
	{
		hash: 'product_name',
		header: 'Product Name',
		render: createDefaultRenderer('product_name'),
	},
	{ hash: 'color', header: 'Color', align: 'center', render: ColorColumn },
	{ hash: 'row', header: 'Row', render: RowNumberColumn },
	{
		hash: 'description',
		header: 'Description',
		render: DescriptionOptionsColumn,
	},
	{ hash: 'note', header: 'Note', render: createDefaultRenderer('note') },
	{
		hash: 'part_number',
		header: 'Part Number',
		render: createDefaultRenderer('part_number'),
	},
	{ hash: 'in_stock', header: 'In Stock', render: InStockColumn },
	{
		hash: 'quantity',
		header: 'Quantity',
		width: 80,
		render: EditQuantityColumn,
	},
	{ hash: 'price', header: 'Price', width: 100, render: PriceEditColumn },
];

export function ItemsInOrderSection() {
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [products, dispatchOrderProducts] = useOrderProducts();
	const { saleTotal: subTotal } = useSubtotal(products);
	const combinedIds = useMemo(
		() => selectedProducts.map(({ combined_id }) => combined_id),
		[selectedProducts],
	);
	const allProducts = useMemo(
		() => getProductsAndAddons(products),
		[products],
	);

	return (
		<Panel header="Items In Order" marginTop="xxxLarge">
			<Table
				items={allProducts}
				columns={tableColumns}
				selectable={{
					selectedItems: selectedProducts,
					onSelectionChange: setSelectedProducts,
				}}
				actions={
					<Box marginLeft="medium">
						<Button
							variant="secondary"
							onClick={() =>
								dispatchOrderProducts(
									removeProducts(combinedIds),
								)
							}
						>
							Delete Selected
						</Button>
					</Box>
				}
			/>
			<Flex flexWrap="wrap" justifyContent="flex-end" paddingTop="large">
				<FlexItem>
					<Box className="sub-total-order-item-box">
						Sub Total: <span>{useFormatCurrency(subTotal)}</span>
					</Box>
				</FlexItem>
			</Flex>
		</Panel>
	);
}
